import CardProfile from '../../02-molecules/card/card-profile/cardProfile';
import CardCourse from '../../02-molecules/card/card-course/cardCourse';

Drupal.behaviors.backpack = {
  async attach(context) {
    const { user } = drupalSettings;
    // Elements  document
    const cardsCourses = document.getElementById('cardsCursesLeft');
    const detailsCourses = document.getElementById('cardsCursesHeader');
    const tabsCourses = document.getElementById('cardsCursesTabs');
    cardsCourses.innerHTML = '<span>Cargando tus cursos ...</span>';

    // data Api

    const BASE_URL = window?.location?.origin ?? '';
    const getToken = async () => {
      try {
        const requestOptions = {
          method: 'GET',
        };
        const response = await fetch(
          `${BASE_URL}/session/token`,
          requestOptions,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.text();
        return result;
      } catch (error) {
        console.error('Error fetching token:', error);
        return null;
      }
    };
    const token = await getToken();

    const requestData = async (payload) => {
      try {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append(
          'Authorization',
          'Basic dW5hYk1pbW9jaGlsYWFoc251Y2s6MTYpUUA6OSdCM3Zx',
        );
        myHeaders.append('X-CSRF-Token', `${token}`);

        const graphql = JSON.stringify(payload);

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: graphql,
          redirect: 'follow',
        };
        const resp = await fetch(`${BASE_URL}/unab`, requestOptions);
        return await resp.json();
      } catch (error) {
        console.error('Error de requestAppointment', error);
        throw error;
      }
    };
    const getParticipants = async (period, nrc) => {
      const { data } = await requestData({
        query: ` query MyQuery($period: String!, $nrc: String!) {
              participants(period: $period, nrc: $nrc) {
                title
                items {
                  alt
                  email
                  src
                  title
                }
              }
            }`,
        variables: {
          period,
          nrc,
        },
      });
      return data?.participants;
    };

    const { data } = await requestData({
      query: `query MyQuery($user: String!) {
        academy(nameUser: $user) {
          title
          textButtonCanvas
          urlButtonCanvas
          textButtonNotes
          urlButtonNotes
          courses {
            course
            modality
            nrc
            period
            section
            title
            schedule {
              title
              items {
                title
                schedules {
                  address
                  currentClass
                  hourEnd
                  hourStart
                  progress
                  type
                }
              }
            }
          }
        }
      }`,
      variables: {
        user: `${user.userName}`,
      },
    });

    // card left

    const cardsContainer = document.createElement('div');
    cardsContainer.classList.add('cards-courses');

    let courseIdActive;

    // Courses
    const titleCourse = document.createElement('h4');
    titleCourse.classList.add('landing-academy__content__header-left-heading');
    titleCourse.innerHTML = 'CURSOS';
    cardsCourses.innerHTML = '';
    cardsCourses.appendChild(titleCourse);

    if (!data?.academy?.courses?.length) {
      cardsCourses.innerHTML = '<span>No tienes cursos en este momento</span>';
    }

    // components

    // card scheduler
    function createScheduleDetailsCard(course) {
      function createCardContent(title, value) {
        return `
            <p class="card-schedule-details__content-right-text">
                <span class="card-schedule-details__content-right-title">
                    ${title}:
                </span>
                ${value}
            </p>
        `;
      }

      function createSeparator() {
        return `<span class="card-schedule-details__content-bottom-item-border"></span>`;
      }

      const cardContent = `
        <div class="card-schedule-details__content">
            <div class="card-schedule__content-left">
              <h4 class="card-schedule__title">${course?.type}</h4>
              <h6 class="card-schedule__hour-start">${
                course?.hourStart
              }<span> hrs.</span></h6>
              <h6 class="card-schedule__hour-end"> Termina ${
                course?.hourEnd
              }</h6>
              ${
                course?.progress
                  ? `
                  <div class="card-schedule__progress">
                    <svg class="icon">
                      <use xlink:href="/themes/custom/unab/dist/icons.svg#clock"></use>
                    </svg>
                    <p class="card-schedule__progress-text">EN PROGRESO </p>
                  </div>`
                  : ''
              }
            </div>
            <div class="card-schedule-details__content-right">
                <h4 class="card-schedule-details__heading">${course?.title}</h4>
                <div class="card-schedule-details__content-right-textContent">
                    <div class="card-schedule-details__content-right-textContent-left">
                        ${createCardContent('NRC', course?.nrc)}
                        ${createSeparator()}
                        ${createCardContent('Curso', course?.course)}
                        ${createSeparator()}
                        ${createCardContent('Sección', course?.section)}
                        <p class="card-schedule-details__address">${
                          course?.address
                        }</p>
                    </div>
                    <svg class="card-schedule-details__content-right-textContent-angle icon">
                        <use xlink:href="/themes/custom/unab/dist/icons.svg#angle-right"></use>
                    </svg>
                </div>
            </div>
        </div>
    `;

      const modalityDiv = `
        <div class="card-schedule-details__modality">
            <svg class="icon">
               <use xlink:href="/themes/custom/unab/dist/icons.svg#dot-circle"></use>
            </svg>
            <p class="card-schedule-details__modality-text">${course?.modality}</p>
        </div>
    `;

      const card = `
        <div class="card-schedule-details ${course?.modality?.toLowerCase()}" >
            ${cardContent}
            ${modalityDiv}
        </div>
    `;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = card;
      return tempDiv.firstElementChild;
    }

    // header
    function createHeader(course) {
      function createHeaderText(title, value) {
        return `
            <p class="landing-academy__content__header-right-header-text">
                <span class="landing-academy__content__header-right-header-title">
                    ${title}:
                </span>
                ${value}
            </p>
        `;
      }

      function createSeparator() {
        return `<span class="landing-academy__content__header-right-header-border"></span>`;
      }

      const headerContent = `
        <div class="landing-academy__content__header-right-header-left">
            <h4 class="landing-academy__content__header-right-header-heading">
                ${course.title}
            </h4>
            <div class="landing-academy__content__header-right-header-bottom">
                ${createHeaderText('NRC', course?.nrc)}
                ${createSeparator()}
                ${createHeaderText('Sección', course?.section)}
                ${createSeparator()}
                ${createHeaderText('Curso', course?.course)}
            </div>
            ${
              course?.modality
                ? `
            <div class="landing-academy__content__header-right-header-modality">
                <svg class="icon ${course?.modality?.toLowerCase()}">
                    <use xlink:href="/themes/custom/unab/dist/icons.svg#circle"></use>
                </svg>
                <p class="landing-academy__content__header-right-header-modality-title landing-academy__content__header-right-header-modality-title--red">
                    ${course?.modality}
                </p>
            </div>`
                : ''
            }
        </div>
    `;

      const rightHeaderContent = `
        <div class="landing-academy__content__header-right-header-right">
            <a class="landing-academy__content__header-right-header-right-link button" href="${data?.academy?.urlButtonCanvas}">
              ${data?.academy?.textButtonCanvas}
            </a>
            <a class="landing-academy__content__header-right-header-right-link button" href="${data?.academy?.urlButtonNotes}">
                ${data?.academy?.textButtonNotes}
            </a>
        </div>
    `;

      const headerHTML = `
        <div class="landing-academy__content__header-right-header">
            ${headerContent}
            ${rightHeaderContent}
        </div>
    `;

      const headerDiv = document.createElement('div');
      headerDiv.innerHTML = headerHTML.trim();

      return headerDiv.firstChild;
    }

    // navbar tasb

    const createNavbarTabs = (nrc) => {
      const navbarTabs = document.createElement('ul');
      navbarTabs.classList.add(
        'landing-academy__content__header-right-tabs-navbar',
      );
      const myClassesLi = document.createElement('li');
      myClassesLi.classList.add(
        'landing-academy__content__header-right-tabs-navbar-item',
        'is-active',
      );
      myClassesLi.textContent = 'MIS CLASES';
      myClassesLi.dataset.id = `myClasses-${nrc}`;

      const participantsLi = document.createElement('li');
      participantsLi.classList.add(
        'landing-academy__content__header-right-tabs-navbar-item',
      );
      participantsLi.textContent = 'PARTICIPANTES';
      participantsLi.dataset.id = `participants-${nrc}`;
      navbarTabs.appendChild(myClassesLi);
      navbarTabs.appendChild(participantsLi);
      return navbarTabs;
    };

    // data source
    const coursesContainer = document.createElement('div');
    coursesContainer.classList.add(
      'landing-academy__content__header-left-item',
    );

    data?.academy?.courses?.forEach((course, index) => {
      if (index === 0) {
        courseIdActive = course.nrc;
      }
      const Card = CardCourse(course, index);
      coursesContainer.insertAdjacentHTML('beforeend', Card);
    });

    cardsCourses.appendChild(coursesContainer);

    // logic for templete

    // tabs
    const eventTabs = () => {
      const tabsNavbar = document.querySelectorAll(
        `#tabs-${courseIdActive} .landing-academy__content__header-right-tabs-navbar-item`,
      );

      tabsNavbar.forEach((tab) => {
        let participantsLoading = false;

        tab.addEventListener('click', async () => {
          const { id } = tab?.dataset;
          const [tabsActive, nrc] = id.split('-');
          const tabActive = document.getElementById(id);

          const tabNavbarRemove = document.querySelectorAll(
            `#tabs-${nrc} .landing-academy__content__header-right-tabs-navbar-item`,
          );
          const tabsContentRemove = document.querySelectorAll(
            `#tabs-${nrc} .landing-academy__content__header-right-tabs-content-item`,
          );
          tabNavbarRemove.forEach((item) =>
            item?.classList?.remove('is-active'),
          );
          tabsContentRemove.forEach((item) =>
            item?.classList?.remove('is-active'),
          );

          tabActive?.classList?.add('is-active');
          tab?.classList?.add('is-active');

          const course = data?.academy?.courses.find((c) => c.nrc === nrc);
          const participantsExist = document.getElementById(
            `participantsItem-${nrc}`,
          );

          if (
            tabsActive === 'participants' &&
            !participantsExist &&
            !participantsLoading
          ) {
            participantsLoading = true;
            const loader = document.createElement('span');
            loader.classList.add('loader');
            loader.textContent = 'Cargando participantes ...';

            const containerParticipants = document.getElementById(
              `participants-${nrc}`,
            );
            containerParticipants.appendChild(loader);

            const participants = await getParticipants(course.period, nrc);
            const participantsElements = document.createElement('div');
            participantsElements.classList.add('section-participants__content');
            participantsElements.id = `participantsItem-${nrc}`;

            participants?.items?.forEach((participants) => {
              const cardParticipants = CardProfile(
                participants.title,
                participants.email,
                participants.src,
                participants.alt,
              );
              participantsElements.appendChild(cardParticipants);
            });
            containerParticipants.removeChild(loader);
            containerParticipants.appendChild(participantsElements);
            participantsLoading = false;
          }
        });
      });
    };

    // cards
    let loadingResponse = false;
    const cardsProgram = document.querySelectorAll(`.card-course`);
    cardsProgram.forEach((card) => {
      card.addEventListener('click', async () => {
        if (!loadingResponse) {
          loadingResponse = true;
          cardsProgram.forEach((item) => item?.classList?.remove('is-active'));
          card.classList.add('is-active');
          const nrc = card.dataset.id;
          const course = data?.academy?.courses.find((c) => c.nrc === nrc);
          courseIdActive = nrc;
          const header = createHeader(course);
          detailsCourses.innerHTML = header.outerHTML;

          // tabs
          detailsCourses.innerHTML = header.outerHTML;
          const tabsContainerRemove = document.querySelectorAll(
            '.landing-academy__content__header-right-tabs',
          );

          tabsContainerRemove.forEach((item) =>
            item?.classList.remove('is-active'),
          );

          const tabsContainerValidate = document.getElementById(`tabs-${nrc}`);
          if (!tabsContainerValidate) {
            const tabs = createNavbarTabs(nrc);
            const tabsContainer = document.createElement('div');
            tabsContainer.classList.add(
              'landing-academy__content__header-right-tabs',
              'is-active',
            );
            tabsContainer.id = `tabs-${nrc}`;
            tabsContainer.appendChild(tabs);

            const schedulerContainer = document.createElement('div');
            schedulerContainer.classList.add(
              'landing-academy__content__header-right-tabs-content-item',
              'is-active',
            );
            schedulerContainer.id = `myClasses-${nrc}`;

            // My classes

            const sectionClasses = document.createElement('div');
            sectionClasses.classList.add('section-classes');
            if (course?.schedule?.items?.length) {
              course?.schedule?.items.forEach((schedules) => {
                const titleSchedule = document.createElement('h5');
                titleSchedule.classList.add('section-classes__heading');
                titleSchedule.textContent = schedules.title;
                sectionClasses.appendChild(titleSchedule);
                schedules.schedules.forEach((schedule) => {
                  const courseData = {
                    title: course.title,
                    nrc: course.nrc,
                    course: course.course,
                    section: course.section,
                    modality: course.modality,
                    address: schedule.address,
                    hourEnd: schedule.hourEnd,
                    hourStart: schedule.hourStart,
                    type: schedule.type,
                    progress: schedule.progress,
                  };
                  const scheduler = createScheduleDetailsCard(courseData);
                  sectionClasses.appendChild(scheduler);
                });
              });
              schedulerContainer.appendChild(sectionClasses);
            } else {
              const titleSchedule = document.createElement('span');
              titleSchedule.textContent = 'No tienes clases en este momento';
              schedulerContainer.appendChild(titleSchedule);
            }

            // participants
            const participantsContainer = document.createElement('div');
            participantsContainer.classList.add(
              'landing-academy__content__header-right-tabs-content-item',
            );
            participantsContainer.id = `participants-${nrc}`;
            tabsContainer.appendChild(schedulerContainer);
            tabsContainer.appendChild(participantsContainer);
            tabsCourses.appendChild(tabsContainer);
            eventTabs();
          } else {
            tabsContainerValidate.classList.add('is-active');
          }

          loadingResponse = false;
        }
      });
      const carActive = card.getAttribute('class');
      if (carActive.includes('is-active')) {
        const nrc = card.dataset.id;
        const course = data?.academy?.courses.find((c) => c.nrc === nrc);
        courseIdActive = nrc;
        const header = createHeader(course);
        detailsCourses.innerHTML = header.outerHTML;
        const tabs = createNavbarTabs(nrc);
        const tabsContainer = document.createElement('div');
        tabsContainer.classList.add(
          'landing-academy__content__header-right-tabs',
          'is-active',
        );
        tabsContainer.id = `tabs-${nrc}`;
        tabsContainer.appendChild(tabs);
        const schedulerContainer = document.createElement('div');
        schedulerContainer.classList.add(
          'landing-academy__content__header-right-tabs-content-item',
          'is-active',
        );
        schedulerContainer.id = `myClasses-${nrc}`;

        // My classes

        const sectionClasses = document.createElement('div');
        sectionClasses.classList.add('section-classes');

        if (course?.schedule?.items?.length) {
          course.schedule.items.forEach((schedules) => {
            const titleSchedule = document.createElement('h5');
            titleSchedule.classList.add('section-classes__heading');
            titleSchedule.textContent = schedules.title;
            sectionClasses.appendChild(titleSchedule);
            schedules.schedules.forEach((schedule) => {
              const courseData = {
                title: course.title,
                nrc: course.nrc,
                course: course.course,
                section: course.section,
                modality: course.modality,
                address: schedule.address,
                hourEnd: schedule.hourEnd,
                hourStart: schedule.hourStart,
                type: schedule.type,
                progress: schedule.progress,
              };
              const scheduler = createScheduleDetailsCard(courseData);
              sectionClasses.appendChild(scheduler);
            });
          });
          schedulerContainer.appendChild(sectionClasses);
        } else {
          const titleSchedule = document.createElement('span');
          titleSchedule.textContent = 'No tienes clases en este momento';
          schedulerContainer.appendChild(titleSchedule);
        }

        // participants
        const participantsContainer = document.createElement('div');
        participantsContainer.classList.add(
          'landing-academy__content__header-right-tabs-content-item',
        );
        participantsContainer.id = `participants-${nrc}`;
        tabsContainer.appendChild(schedulerContainer);
        tabsContainer.appendChild(participantsContainer);
        tabsCourses.innerHTML = tabsContainer.outerHTML;
        eventTabs();
      }
    });
  },
};
